import React from 'react';
import { Container } from 'react-bootstrap';

const caseStudies = [
  {
    industry: 'CPG / Convenience Distribution',
    industryClass: 'food',
    title: 'Topicz and Shop the King: ecommerce built from zero',
    description:
      'Built the operating foundation for a multigenerational Cincinnati distributor entering ecommerce for the first time, then helped evolve that foundation into a marketplace management accelerator for nationally distributed CPG brands.',
    metrics: [
      { value: '2020', label: 'Built from the ground up' },
      { value: '30K+', label: 'SKUs managed across channels' },
      { value: '8+', label: 'Marketplaces and sales channels' },
      { value: 'Full', label: 'Catalog, workflow, and reporting stack' }
    ]
  },
  {
    industry: 'Legacy Distribution / Specialty Supply',
    industryClass: 'industrial',
    title: 'Marketplace strategy for operators with complex catalogs',
    description:
      'Applied marketplace and ecommerce strategy across legacy distribution environments including HVAC, plumbing supply, apparel, specialty retail, and CPG, where SKU complexity, vendor data, and team adoption determine whether digital work actually scales.',
    metrics: [
      { value: '20+', label: 'Years selling and building online' },
      { value: 'Global', label: 'Marketplace sales experience' },
      { value: 'B2B', label: 'Distributor workflows understood' },
      { value: 'Practical', label: 'Systems built around real operators' }
    ]
  },
  {
    industry: 'AI Implementation / Operations',
    industryClass: 'consumer',
    title: 'Automation that turns manual work into operating leverage',
    description:
      'Designs AI systems around measurable operational outcomes: product data enrichment, reporting, workflow automation, marketplace readiness, and human-in-the-loop processes your team can keep using after launch.',
    metrics: [
      { value: 'ROI', label: 'Prioritized before build' },
      { value: 'Agents', label: 'Built into existing workflows' },
      { value: 'Team', label: 'Training and adoption included' },
      { value: 'Owned', label: 'Infrastructure stays with you' }
    ]
  }
];

const CaseStudies = () => {
  return (
    <section className="wn-section wn-section-soft" id="results">
      <Container>
        <div className="text-center wn-fade-in">
          <div
            className="wn-section-label"
            style={{ justifyContent: 'center' }}
          >
            <span className="label-dot" />
            Proof of Work
          </div>
          <h2 className="wn-section-title centered">
            Built in the messy middle, where legacy operations become modern
            ones.
          </h2>
          <p className="wn-section-subtitle centered">
            The pattern is consistent: understand the operation, build the
            infrastructure, train the team, and measure the outcome in business
            terms.
          </p>
        </div>

        <div className="wn-case-grid">
          {caseStudies.map((cs, i) => (
            <div
              key={i}
              className={`wn-case-card wn-fade-in wn-fade-in-delay-${i + 1}`}
            >
              <span className={`case-industry ${cs.industryClass}`}>
                {cs.industry}
              </span>
              <h3>{cs.title}</h3>
              <p>{cs.description}</p>
              <div className="case-metrics">
                {cs.metrics.map((m, j) => (
                  <div key={j} className="metric">
                    <div className="metric-value">{m.value}</div>
                    <div className="metric-label">{m.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CaseStudies;
